import HttpClient from '@microbadevs/http-client'
import authService from '@/services/authService'

export default class HttpClientService {
  static getAPIHttpClient () {
    return new HttpClient(localStorage.getItem('api_path'), process.env.API_USER, process.env.API_PASS, authService.getAccessToken(), authService.getRefreshToken())
  }
}
